import orderBy from "lodash/orderBy";

import { IndustrialProcessSchema, ProcessStep, ProductLine } from "../types";

export const getQuoteRequestLineProductLines = (quoteRequestLine: {
  processSteps: {
    industrialProcess: ProcessStep["industrialProcess"];
    productLines: ProductLine[];
  }[];
}) => {
  const persistedProductsProcessStep = quoteRequestLine.processSteps.find(
    (processStep) => processStep.industrialProcess === IndustrialProcessSchema.enum.PRODUCTS,
  );

  const productLines = orderBy(
    persistedProductsProcessStep?.productLines ?? [],
    ["createdAt", "product.name"],
    ["asc", "asc"],
  );

  return productLines;
};
